<template>
  <div
    v-if="productHydrated"
    class="ProductCard relative h-full"
    :class="{
      'px-12 desk:px-0': design === 'list',
    }"
  >
    <!--    <DebugOutput v-if="index === 0">{{ product.relatedProducts }}</DebugOutput>
    <DebugOutput v-if="index === 0" position="right">{{ showSampleButton }}</DebugOutput>-->
    <!-- * * * * * * * List view
    This is heavily modify for Kährs vs other projects
    -->
    <div
      v-if="design === 'list'"
      class="w-full
      flex flex-col desk:flex-row gap-8 desk:gap-24 desk:justify-between desk:items-center
      border-b border-light py-12"
    >
      <!-- image, name and stock -->
      <nuxt-link :to="link" class="flex justify-start gap-8 desk:gap-12 desk:basis-[40%]">
        <!-- image -->
        <div class="basis-[54px] desk:basis-64 shrink-0 relative">
          <img
            v-if="!quickBuyActiveVariant.image"
            src="/icons/no-image.svg"
            class="object-cover w-[54px] desk:w-64 aspect-square "
            alt="no image"
          >
          <nuxt-img
            v-else
            :src="quickBuyActiveVariant.image"
            provider="norce"
            preset="plpimage"
            :sizes="sizes"
            class="object-cover w-[54px] desk:w-64 aspect-square group-hover:scale-110 transition ease-out duration-300"
            :alt="productHydrated.name"
            :loading="placement > 1 ? 'lazy':'eager'"
          />
          <div class="imageOverlay absolute top-0 left-0 w-full h-full pointer-events-none" />
        </div>
        <!-- name etc -->
        <div class="type-sm">
          <div class="type-headline-sm mb-4">{{ quickBuyActiveVariant.name }}</div>

          <div
            v-if="globalContent.getCountryCode === 'de' && isFloor && !miniCart && !featured"
            class="mb-4"
          >
            {{ productHydrated.parametricByCode('ProductConstruction')?.listValue?.name }}
          </div>
          <div v-else-if="productHydrated.lastChildCategory?.name" class="mb-4">
            {{ productHydrated.lastChildCategory.name }}
          </div>
          <StockStatus
            v-if="userPrice.status !== 'notLoggedIn' && !hideResilientStockStatus && !globalContent.disablePricingAndPurchase"
            :variant="quickBuyActiveVariant"
            :product-item="productHydrated"
            :use-short-labels="true"
            :is-product-card="true"
            :use-area="true"
            use-primary-stock-status
          />
          <div v-else-if="globalContent.getCountryCode === 'de'" class="type-xs">{{ $t('resilient.contactSales') }}</div>
          <span class="hidden">{{ productHydrated.priceFetchPartNo }}</span>
        </div>
      </nuxt-link>

      <!-- variants -->
      <VariantSelector
        v-if="userStore.isLoggedIn && !product.isStructureArticle && productHydrated.hasAnyBuyableVariant"
        class="relative desk:basis-[18%]"
        :product-item="productHydrated"
        :active-variant="quickBuyActiveVariant"
        design="list"
        @update-active-variant="(variant) => quickBuyActiveVariant = variant"
      />

      <div v-if="userPrice.status === 'notLoggedIn'">
        <div
          class="btn--text"
          @click.prevent="showLogin"
        >
          {{ $t('price.notLoggedIn') }}
        </div>
      </div>
      <!-- amount selector, price and buy -->
      <div
        v-else
        class="desk:basis-[42%] flex justify-between desk:justify-end items-center gap-8"
      >
        <!-- amount selector -->
        <PackageToAreaConverter
          v-if="shouldUseArea && productHydrated.hasAnyBuyableVariant && !globalContent.getIsB2c"
          v-model="totalQuantity"
          :input="quickBuyActiveVariant"
          design="plpcompact"
        />

        <TouchNumber
          v-else-if="quickBuyActiveVariant.canAddToCart && !globalContent.getIsB2c"
          v-model="totalQuantity"
          :show-buttons-on-desktop="true"
          class="basis-[130px]"
        />
        <!-- price and buy -->
        <div v-if="!hideResilientProducts && !globalContent.disablePricingAndPurchase" class="flex gap-8 items-center">
          <ProductPrice
            :crossell="false"
            :product-item="productHydrated"
            :active-variant="quickBuyActiveVariant"
            design="plpCompact"
            class="text-right w-72"
          />
          <button
            v-if="!globalContent.getIsB2c"
            class="btn btn--wIcon !w-32 !h-32 desk:w-40 desk:h-40"
            :aria-label="$t('quickbuy.button')"
            :disabled="!quickBuyActiveVariant.canAddToCart"
            :class="{
              loading: buyLoading,
            }"
            @click="buyProduct"
          >
            <img src="/icons/cart-inv.svg" class="inline-block w-20">
          </button>
        </div>
      </div>
    </div>
    <!-- * * * * /list view -->

    <div v-else-if="design === 'accessories'" class="flex justify-between mb-12 gap-12">
      <div class="basis-96 shrink-0 relative">
        <div
          v-if="showQuickbuy"
          class="absolute bottom-16 right-16"
        >
          <button
            v-if="quickBuyActiveVariant.canAddToCart"
            class="bg-darkest h-32 w-32 text-center flex items-center justify-center hover:bg-darker transition-all"
            :title="$t('quickbuy.button')"
            @click="openQuickbuy"
          >
            <img
              src="/icons/cart-add-inv.svg"
              class="w-20 h-20"
              alt=""
            >
          </button>
        </div>

        <nuxt-img
          :src="currentImage"
          provider="norce"
          preset="plpimage"
          :sizes="sizes"
          class="w-full h-full object-cover opacity-100 group-hover:opacity-80 transition ease-out duration-500"
          :class="{
            'max-w-full max-h-full object-cover': productHydrated.extendedLayout,
          }"
          :alt="productHydrated?.name || ''"
          :loading="placement > 1 ? 'lazy':'eager'"
        />
      </div>
      <div class="basis-full">
        <nuxt-link
          :to="link"
          :class="{
            'pointer-events-none': userStore.isLoggedIn && pointShop
          }"
          @click="track"
        >
          <div class="type-headline-sm mb-2">{{ productHydrated.name }}</div>
          <div v-if="productHydrated.lastChildCategory?.name" class="type-sm mb-4">
            {{ productHydrated.lastChildCategory.name }}
          </div>

          <ProductPrice
            v-if="!globalContent.disablePricingAndPurchase"
            :crossell="false"
            :product-item="productHydrated"
            :active-variant="quickBuyActiveVariant"
            design="plpGrid"
          />

          <StockStatus
            v-if="!globalContent.disablePricingAndPurchase"
            :variant="quickBuyActiveVariant"
            :product-item="productHydrated"
            :use-short-labels="true"
            :is-product-card="true"
            :use-area="true"
            use-primary-stock-status
          />
        </nuxt-link>
      </div>
    </div>

    <!-- * * * * * * * Grid view -->
    <div
      v-else
      :class="{
        'flex bg-bg-brandSubtle': featured,
      }"
      @mouseenter="imageHoverering = true"
      @mouseleave="imageHoverering = false"
    >
      <div
        class="relative aspect-product group overflow-hidden cursor-pointer"
        :class="{
          'hidden': design === 'hotSpot',
          'basis-1/3 desk:basis-1/2': featured,
        }"
      >
        <div
          v-if="!image"
        >
          <img
            src="/icons/no-image.svg"
            class="object-cover"
            alt="no image"
          >
        </div>
        <div
          v-else
          class="w-full h-full flex items-center justify-center relative"
        >
          <nuxt-img
            :src="currentImage"
            provider="norce"
            preset="plpimage"
            :sizes="sizes"
            class="w-full h-full object-cover opacity-100 group-hover:opacity-80 transition ease-out duration-500"
            :class="{
              'max-w-full max-h-full object-cover': productHydrated.extendedLayout,
            }"
            :alt="productHydrated?.name || ''"
            :loading="placement > 1 ? 'lazy':'eager'"
          />
        </div>

        <nuxt-link
          :to="link"
          :class="{
            'pointer-events-none': userStore.isLoggedIn && pointShop
          }"
          @click="track"
        >
          <div
            class="imageOverlay absolute top-0 left-0 w-full h-full"
          />
        </nuxt-link>

        <div v-if="userStore.canFavorizeProducts && !productHydrated.extendedLayout && !featured" class="absolute top-8 right-8 desk:top-12 desk:right-12">
          <FavoriteButton
            :product="productHydrated"
            :design="design"
          />
        </div>

        <div
          v-if="showQuickbuy && !featured && !hideResilientProducts && !globalContent.disablePricingAndPurchase"
          class="absolute desk:bottom-12 desk:right-12 bottom-8 right-8"
        >
          <button
            v-if="quickBuyActiveVariant.canAddToCart"
            class="bg-darkest h-32 w-32 text-center flex items-center justify-center hover:bg-darker transition-all"
            :title="$t('quickbuy.button')"
            @click="openQuickbuy"
          >
            <img
              src="/icons/cart-add-inv.svg"
              class="w-20 h-20"
              alt=""
            >
          </button>
          <InstantBuyBox
            v-else
            :product-item="productHydrated"
            :active-variant="quickBuyActiveVariant"
          />
        </div>

        <!-- flags, top left -->
        <div class="type-tagline-xs leading-single absolute left-8 top-8 desk:left-12 desk:top-12">
          <!-- user price discount percent -->
          <div
            v-if="userPrice.price?.isCampaignPrice && userPrice.price?.discountPercentage && userPrice.price.discountPercentage > 0"
            class="inline-block text-center leading-single px-12 py-8 mb-4 bg-bg-errorStrong text-text-inverse"
          >
            {{ userPrice.price.discountPercentage }}%
          </div>

          <!-- campaign text from flags -->
          <div
            v-if="productHydrated.hasBulkDiscount"
            class="inline-block text-center leading-single px-4 py-4 text-dark"
          >
            {{ productHydrated.isGiftCampaign ? $t('buyMore.plp.gift-flag') : $t('buyMore.plp.flag') }}
          </div>

          <div
            v-for="flag in productHydrated.productCardDisplayFlags"
            :key="flag.code"
          >
            <div
              v-if="shouldShowFlag(flag.code)"
              :style="`background-color: ${flag.background}`"
              class="inline-flex items-center justify-center p-4 desk:p-6 type-tagline-xs leading-single bg-bg-inverse text-text-inverse rounded-2"
              :class="{
                'text-lightest h-24 px-8 py-[7px] relative desk:top-4 desk:left-4': isDarkFlag(flag.background),
              }"
            >
              {{ flag.text }}
            </div>
          </div>

          <!-- Hidden Product -->
          <div v-if="productHydrated.isHiddenProduct" class="leading-single px-4 py-4 text-dark">
            <img
              alt=""
              src="/icons/eye-closed.svg"
              class="w-[16px] h-[16px]"
            >
          </div>
        </div>

        <!-- more variants - bottom left -->
        <div
          v-if="productHydrated.hasVariants && quickBuyActiveVariant.canAddToCart && !pointShop && !featured"
          class="absolute left-8 bottom-8 desk:left-12 desk:bottom-12 inline-flex items-center justify-center p-4 desk:p-6 type-tagline-xs leading-single bg-bg-inverse text-text-inverse rounded-2"
          :class="{
            nextToQuickbuy: showQuickbuy,
            'hidden': design === 'miniCart',
          }"
        >
          {{ $t('productList.product.hasVariants') }}
        </div>
      </div>
      <div
        :class="{
          'w-full': !featured,
          'basis-2/3 desk:basis-1/2 p-16 desk:p-24 flex flex-col justify-center': featured,
          'px-0 desk:px-0 pt-0 desk:pt-0 pb-0': design === 'hotSpot',
          'px-8 pt-12 desk:px-0 desk:pt-12 pb-32': design === 'standard',
        }"
      >
        <nuxt-link
          :to="link"
          :class="{
            'pointer-events-none': userStore.isLoggedIn && pointShop
          }"
          @click="track"
        >
          <div v-if="featured" class="type-tagline text-text-subtle mb-4">{{ productHydrated.lastChildCategory?.name }}</div>
          <div v-if="miniCart" class="type-tagline-sm text-text-subtle">{{ productHydrated.partNo }}</div>
          <div
            class="type-headline-sm mb-2"
            :class="{
              'mt-8 desk:mt-12': design === 'small'
            }"
          >
            {{ productHydrated.name }}
          </div>

          <div
            v-if="globalContent.getCountryCode === 'de' && isFloor && !miniCart && !featured"
            class="type-sm text-text-subtle"
          >
            {{ productHydrated.parametricByCode('ProductConstruction')?.listValue?.name }}
          </div>

          <div v-else-if="productHydrated.lastChildCategory?.name && !miniCart && !featured" class="type-sm text-text-subtle mb-4">
            {{ productHydrated.lastChildCategory.name }}
          </div>

          <div
            v-if="showShortDescription"
            class="type-sm text-text-subtle mb-24"
            v-html="productHydrated.shortDescription"
          />

          <div
            v-if="productHydrated.extendedLayout"
            class="leading-single type-xs-medium desk:type-sm-medium"
          >
            <div v-if="productHydrated.hasVariants">
              {{ $t('productPage.extended.shades', { num: productHydrated.partNumbers.length }) }}
            </div>
          </div>
          <div v-else-if="!hideResilientProducts && !globalContent.disablePricingAndPurchase">
            <div class="type-label-sm">
              <div
                v-if="userPrice.status === 'logginIn' || userPrice.status === 'pending'"
                class="priceLoadBox"
              >
                {{ productPrice(productHydrated.priceInfo, 'price', true)?.replace(/\d/g, '&nbsp;') }}
              </div>
              <div
                v-if="userPrice.status === 'notLoggedIn'"
                class="btn--text whitespace-normal"
                @click.prevent="showLogin"
              >
                {{ $t('price.notLoggedIn') }}
              </div>

              <div
                v-if="userPrice.status === 'error' && globalContent.getIsB2b"
                class="text-criticalDark"
              >
                ---
              </div>

              <ProductPrice
                :crossell="false"
                :product-item="productHydrated"
                :active-variant="quickBuyActiveVariant"
                design="plpGrid"
              />
            </div>
          </div>
        </nuxt-link>
        <button
          v-if="showSampleButton && !hideResilientProducts && !globalContent.disablePricingAndPurchase"
          class="btn w-full btn--md mt-8"
          :disabled="sampleInCart"
          :class="{
            loading: buyingSample
          }"
          @click="buySample"
        >
          <span v-if="sampleInCart">{{ $t('plp.sampleInCart') }}</span>
          <span v-else>{{ $t('plp.buySample') }}</span>
        </button>
        <div
          v-if="userPrice.status !== 'notLoggedIn' && design !== 'small' && !globalContent.getIsB2c && !hideResilientStockStatus && !globalContent.disablePricingAndPurchase"
          class="flex items-center px-4 py-2 mt-6 desk:mt-8"
        >
          <StockStatus
            :variant="quickBuyActiveVariant"
            :product-item="productHydrated"
            :use-short-labels="true"
            :is-product-card="true"
            :use-area="true"
            use-primary-stock-status
          />
        </div>
      </div>
      <div v-if="featured && userStore.isLoggedIn" class="absolute top-8 right-8 desk:top-12 desk:right-12">
        <FavoriteButton
          :product="productHydrated"
          :design="design"
        />
      </div>
      <div
        v-if="showQuickbuy && featured"
        class="absolute desk:bottom-12 desk:right-12 bottom-8 right-8"
      >
        <button
          v-if="quickBuyActiveVariant.canAddToCart"
          class="bg-darkest h-32 w-32 text-center flex items-center justify-center hover:bg-darker transition-all"
          :title="$t('quickbuy.button')"
          @click="openQuickbuy"
        >
          <img
            src="/icons/cart-add-inv.svg"
            class="w-20 h-20"
            alt=""
          >
        </button>
        <InstantBuyBox
          v-else
          :product-item="productHydrated"
          :active-variant="quickBuyActiveVariant"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FavoriteButton from '~/components/product/FavoriteButton.vue';
import { useUiStore } from '~/store/ui';
import { storeToRefs } from 'pinia';
import { ProductRaw } from '~/constants/types/algolia';
import Product, { ProductModel } from '~/models/product';
import { useCartStore } from '~/store/cart';
import { useGlobalContentStore } from '~/store/globalContent';
import { useUserStore } from '~/store/user';
import { isLight } from '~/util/colorUtil';
import PointShopAmount from '~/components/product/PointShopAmount.vue';
import { createDataLayerItem, sendDataLayer } from '~/composeables/useTracking';
import useLinkReplacer from '~/composeables/useLinkReplacer';
import { ref } from 'vue';
import { ProductVariantModel } from '~/models/productVariant';
import VariantSelector from '~/components/product-page/VariantSelector.vue';
import InstantBuyBox from '~/components/product/InstantBuyBox.vue';
import ProductPrice from '~/components/product-page/ProductPrice.vue';
import StockStatus from '~/components/product/StockStatus.vue';
import usePrices from '~/composeables/usePrices';
import PackageToAreaConverter from '~/components/product-page/PackageToAreaConverter.vue';
import usePackageAreaConverter from '~/composeables/usePackageAreaConverter';
import TouchNumber from '~/components/form-elements/TouchNumber.vue';
import { NorceRelatedProductTypeCodes } from '~/constants/norceCodes';
import useAlgoliaFetch from '~/composeables/useAlgoliaFetch';

const cartStore = useCartStore();
const userStore = useUserStore();
const globalContent = useGlobalContentStore();
const uiStore = useUiStore();
const { listImageSize } = storeToRefs(uiStore);
const { productPrice } = usePrices();
const { getProductByPartNo } = useAlgoliaFetch();

const { productUrl } = useLinkReplacer();
const props = defineProps<{
  product: ProductRaw | ProductModel,
  enableQuickBuy: boolean,
  enableBuySample?: boolean,
  placement: number, // the placement of list component
  index?: number, // the placement inside the list
  design: 'standard' | 'featured' | 'small' | 'list' | 'hotSpot' | 'multiQuickbuy' | 'accessories' | 'miniCart',
  pointShop?: boolean,
  isUpsell?: boolean,
  useVariantImage?: boolean, // if the list from algolia is distinct = true, we show the variant image
  listIndex?: string,
}>();

defineEmits(['quickbuy']);

const productHydrated = props.product instanceof Product ? props.product : Product.create(props.product);
if (!(props.product instanceof Product)) {
  console.warn(`Using ProductCard from ProductRaw is not recommended: ${productHydrated.partNo}`);
}

const setPrimaryToActive = () => {
  if (productHydrated) {
    let primaryVariant = props.listIndex?.includes('price')
      ? productHydrated.variants.findIndex((f) => f.partNo === props.product.partNo)
      : productHydrated.variants.findIndex((f) => f.isPrimary);
    if (primaryVariant === -1) {
      primaryVariant = 0;
    }
    quickBuyActiveVariant.value = productHydrated.variants[primaryVariant];
  }
};
const quickBuyActiveVariant = ref<ProductVariantModel>(productHydrated.variants[0]);

const {
  shouldUseArea,
} = usePackageAreaConverter(quickBuyActiveVariant);
const totalQuantity = ref(1);

setPrimaryToActive();

const imageHoverering = ref(false);
const image = computed(() => {
  if (props.useVariantImage && productHydrated.variantImage) {
    return productHydrated.variantImage;
  }
  // check if we have a "swatch image"
  const swatchImage = productHydrated.mediaSets.find(f => f.code === 'PrimaryImage');
  if (swatchImage && swatchImage.media[0]) {
    return swatchImage.media[0].url;
  }

  return productHydrated.listImage;
});
const hoverImage = computed(()=> {
  const hoverImage = productHydrated.mediaSets.find(f => f.code === 'InteriorImage');
  if (hoverImage && hoverImage.media[0]) {
    return hoverImage.media[0].url;
  }
  return null;
});

const currentImage = computed(()=> {
  if (imageHoverering.value && hoverImage.value) {
    return hoverImage.value;
  }
  return image.value;
});

const featured = computed(()=> {
  return props.design === 'featured';
});

const miniCart = computed(()=> {
  return props.design === 'miniCart';
});

const showShortDescription = computed(()=> {
  return productHydrated.shortDescription && (featured.value || miniCart.value);
});

const link = computed<string>(()=> {
  return productUrl(productHydrated.url);
});

const userPrice = computed(()=> {
  return props.pointShop || props.listIndex?.includes('price') ?
    userStore.getPrice(productHydrated.partNo, props.isUpsell) :
    userStore.getPrice(productHydrated.priceFetchPartNo, props.isUpsell);
});

const openQuickbuy = async() => {
  cartStore.setCurrentlyBuying(productHydrated, props.isUpsell, !props.listIndex?.includes('price'));
  uiStore.setShowQuickBuy(true);
  uiStore.setShowMiniCart(false);
};

const track = () => {
  sendDataLayer(
    'select_item',
    [ createDataLayerItem(props.product) ],
    {
      'item_list_name': globalContent.currentStory?.name,
      'item_list_id': globalContent.currentStory?.id,
    }
  );
};

const sizes = computed(()=> {
  if (props.design === 'list') {
    return 'mob375:56px';
  }
  switch (listImageSize.value) {
    case 'lg':
      return 'mob375:100vw mob390:100vw mob414:100vw desk:538px';
    case 'sm':
      return 'mob375:368px mob390:382px mob414:406px desk:538px';
  }
  return 'mob375:368px mob390:382px mob414:406px desk:538px';
});

const showLogin = () => {
  uiStore.setShowSigninModal(true, true);
};

const isDarkFlag = (input: string | null | undefined) => {
  if (!input) {
    return false;
  }
  return !isLight(input);
};

const isUserDiscounted = computed(()=> {
  return userStore.isSalePrice(productHydrated.priceFetchPartNo);
});

const showQuickbuy = computed(()=> {
  return props.enableQuickBuy && userStore.isLoggedIn && !productHydrated.extendedLayout && !props.pointShop;
});

const shouldShowFlag = (code: string) => {
  if (code === 'onDemand') {
    const anyInStock = props.product.variantStockStatuses.some((s) => s.inStock > 0);
    return !anyInStock;
  }
  return true;
};

const buyLoading = ref(false);
const buyProduct = async() => {
  buyLoading.value = true;
  await cartStore.updateCart(
    quickBuyActiveVariant.value.partNo,
    totalQuantity.value,
    -1,
    true,
    quickBuyActiveVariant.value
  );
  buyLoading.value = false;
};

// if it's floor or accessories
const isFloor = computed(()=> {
  return productHydrated.categories.some((s) => {
    return s.code === 'Wood' || s.code === 'Vinyl';
  });
});

/**
 * Hides price/purchase buttons for resilient products (US/DE)
 */
const hideResilientProducts = computed(()=> {
  const isResilient = productHydrated.categories.some(f => f.code === 'Resilient' || f.code === 'ResilientAccessories');
  return isResilient && globalContent.disableResilientPricingAndPurchase;
});

// Hides stock status for resilient products (shows for logged in users in US, always hidden in DE)
const hideResilientStockStatus = computed(()=> {
  const isResilient = productHydrated.categories.some(f => f.code === 'Resilient' || f.code === 'ResilientAccessories');
  return isResilient && globalContent.disableResilientStockStatus;
});

const showSampleButton = computed<string | null>(() => {
  if (props.enableBuySample) {
    const samples = props.product.relatedProducts?.filter(f => f.code === NorceRelatedProductTypeCodes.Samples).find((s) => s.partNo?.toUpperCase().startsWith('SA01'));;
    if (samples) {
      return samples.partNo;
    }
  }
  return null;
});
const buyingSample = ref(false);

const buySample = async() => {
  if (showSampleButton.value) {
    buyingSample.value = true;
    await cartStore.updateCart(
      showSampleButton.value,
      1,
      -1,
      false
    );
    buyingSample.value = false;

    // tracking
    const item = await getProductByPartNo(showSampleButton.value);
    if (item?.hits && item.hits.length) {
      sendDataLayer(
        'add_sample_to_cart',
        [ createDataLayerItem(item.hits[0]) ]
      );
    }

  }
};

const sampleInCart = computed(()=> {
  if (showSampleButton.value) {
    const inCart = cartStore.cart.items.findIndex(f => f.partNo === showSampleButton.value);
    return (inCart > -1);
  }
  return false;
});

</script>

<style scoped lang="postcss">

.product-description {
  margin-top: 8px;
}

.priceLoadBox {
  @apply inline-block;
  color: rgba(0,0,0,0);
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
}

@keyframes spin {
  from {
    background-color: #DEDDD9;
  }
  to {
    background-color: #F5F4F0;
  }
}

.nextToQuickbuy {
  /* 100% - padding - button size - margin to button */
  max-width: calc(100% - 16px - 32px - 4px);
}

</style>
